import {CdkDrag, CdkDropList, CdkDropListGroup, DragDropModule} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input-gg';
import {CoreCommonModule} from '../../../../../../../@core/common.module';
import {SharedModule} from '../../../../../shared/shared/shared.module';
import {TableModule} from '../../../../../shared/shared/table/table.module';
import {UploadFilesModule} from '../../../../../shared/upload-files/upload-files.module';
import {ImportSummaryStepComponent} from './import-summary-step/import-summary-step.component';
import {IsMappingFieldRequiredPipe} from './match-columns-step/is-mapping-field-required.pipe';
import {MatchColumnsStepComponent} from './match-columns-step/match-columns-step.component';
import {MatchContractCardsStepComponent} from './match-contract-cards-step/match-contract-cards-step.component';
import {UploadFilesInitStepComponent} from './upload-files-init-step/upload-files-init-step.component';
import {UploadPreviewStepComponent} from './upload-preview-step/upload-preview-step.component';
import { BulkUploadPDFFilesStepComponent } from './bulk-upload-pdf-files-step/bulk-upload-pdf-files-step.component';
import { IdIncludedPipe } from './bulk-upload-pdf-files-step/id-included.pipe';
import { DocTypeFromPdfPipe } from './bulk-upload-pdf-files-step/match-item/doc-type-from-pdf.pipe';
import { CategoryFromPdfPipe } from './bulk-upload-pdf-files-step/match-item/category-from-pdf.pipe';
import { ContractCardFromPdfPipe } from './bulk-upload-pdf-files-step/match-item/contract-card-from-pdf.pipe';
 
@NgModule({
  declarations: [
      UploadFilesInitStepComponent,
      MatchContractCardsStepComponent,
      ImportSummaryStepComponent,
      MatchColumnsStepComponent,
      UploadPreviewStepComponent,
      BulkUploadPDFFilesStepComponent
  ],
    imports: [CommonModule, TableModule, CoreCommonModule, SharedModule, NgbModule, NgSelectModule, DragDropModule, CdkDrag, CdkDropList, CdkDropListGroup, TranslocoDirective, UploadFilesModule, IsMappingFieldRequiredPipe, DocTypeFromPdfPipe, ContractCardFromPdfPipe, CategoryFromPdfPipe, IdIncludedPipe, NgxIntlTelInputModule],
    exports:[
        UploadFilesInitStepComponent,
        MatchContractCardsStepComponent,
        ImportSummaryStepComponent,
        MatchColumnsStepComponent,
        UploadPreviewStepComponent,
        BulkUploadPDFFilesStepComponent
    ]
})
export class BulkUploadStepsModule { }
